import { METRIKA_ID } from '../constants';
export function getMetrikaCounterName() {
  return "yaCounter".concat(METRIKA_ID);
}
export function sendMetrika(goal) {
  var counterData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var metrika = window[getMetrikaCounterName()];
  if (metrika) {
    metrika.reachGoal(goal, counterData);
  }
}
export function initMetrika(onInit) {
  var hasMetrika = window.Ya && (Ya.Metrika || Ya.Metrika2);
  var fn = function fn() {
    var counterName = getMetrikaCounterName();
    if (!window[counterName]) {
      var Metrika = Ya.Metrika || Ya.Metrika2;
      window[counterName] = new Metrika({
        id: METRIKA_ID,
        trackLinks: true,
        accurateTrackBounce: true,
        triggerEvent: true
      });
    }
    if (onInit) {
      onInit();
    }
  };
  if (hasMetrika) {
    fn();
  } else {
    var callbackKey = 'yandex_metrika_callbacks';
    (window[callbackKey] || (window[callbackKey] = [])).push(fn);
    (window["".concat(callbackKey, "2")] || (window["".concat(callbackKey, "2")] = [])).push(fn);
  }
}
export function loadMetrika() {
  /* eslint-disable */
  // prettier-ignore
  (function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
    // @ts-expect-error
    m[i].l = 1 * new Date();
    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  /* eslint-enable */

  return null;
}
// #sourceMappingURL=metrika.js.map